var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "ui small blue button",
        attrs: { type: "button" },
        on: { click: _vm.openPicker }
      },
      [_vm._t("default", [_vm._v("Choose existing photo")])],
      2
    ),
    _vm._v(" "),
    _c("div", { ref: "modal", staticClass: "ui large modal" }, [
      _c("div", { staticClass: "header" }, [
        _vm._v("\n            Choose existing file\n            "),
        _c("div", { staticClass: "path-row" }, [
          _c("strong", [_vm._v("Path: ")]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "breadcrumbs" },
            _vm._l(_vm.crumbs, function(crumb) {
              return _c(
                "li",
                {
                  on: {
                    click: function($event) {
                      _vm.getFolder(crumb.subpath)
                    }
                  }
                },
                [_vm._v(_vm._s(crumb.crumb))]
              )
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "scrolling content" }, [
        _c("div", { staticClass: "ui grid" }, [
          _vm.subfolders.length > 0
            ? _c("div", { staticClass: "col-6" }, [
                _c("strong", [_vm._v("Sub-folders")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "clickable-list" },
                  _vm._l(_vm.subfolders, function(dir) {
                    return _c(
                      "li",
                      {
                        on: {
                          click: function($event) {
                            _vm.getSubFolder(dir)
                          }
                        }
                      },
                      [_vm._v(_vm._s(dir))]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.subfolders.length > 0 ? "col-10" : "col-16" },
            [
              _c("strong", [_vm._v("Files")]),
              _vm._v(" "),
              _vm.files.length === 0
                ? _c("p", [_vm._v("No files found")])
                : _vm._e(),
              _vm._v(" "),
              _vm.files.length > 0
                ? _c(
                    "ul",
                    { staticClass: "clickable-list imgs" },
                    _vm._l(_vm.files, function(file) {
                      return _c(
                        "li",
                        {
                          on: {
                            click: function($event) {
                              _vm.selectFile(file.name)
                            }
                          }
                        },
                        [
                          file.image
                            ? _c("img", {
                                attrs: {
                                  src: "/" + _vm.path + "/" + file.name,
                                  title:
                                    file.name +
                                    (file.width
                                      ? " (" +
                                        file.width +
                                        "×" +
                                        file.height +
                                        ")"
                                      : "")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !file.image
                            ? _c("div", { staticClass: "non-image-file" }, [
                                _c("i", { staticClass: "icon file outline" }),
                                _vm._v(" " + _vm._s(file.name))
                              ])
                            : _vm._e()
                        ]
                      )
                    })
                  )
                : _vm._e()
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "actions" }, [
      _c("div", { staticClass: "ui cancel button" }, [_vm._v("Cancel")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a9eff96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9eff96","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/chooseExistingFile.vue
// module id = 534
// module chunks = 0